// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React from 'react';
import classNames from '@ta/common.classnames';
import styles from './ProgressIndicator.css';

type Props = {|
  active: boolean,
  stepNumber: number,
  stepCount: number,
|};

/**
 * A visual hint for how far the user is in the onboarding flow
 */
const ProgressIndicator = ({ active, stepNumber, stepCount }: Props) => {
  const transform = `scaleX(${active ? stepNumber / stepCount : 0})`;

  return (
    <div className={classNames(styles.progressIndicator, { [styles.disabled]: !active })}>
      <div
        className={styles.bar}
        style={{
          transform,
          WebkitTransform: transform,
          msTransform: transform,
        }}
      />
      <div className={styles.ticks}>
        {Array(stepCount)
          .fill(0)
          .map((_, index) => index)
          .map(step => (
            <div key={step} className={styles.tick} />
          ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;
